import { useQuery } from '@tanstack/react-query';
import api from '../../../services';
import { sortByName } from '../../../utils/sorting';

const fetchCurrentCapAmount = async (id) => {
  return api.get(`offer-action/current-cap-amount/daily/${id}`).then((res) => res.data);
};

export const useCurrentCapAmount = (id) =>
  useQuery({
    queryKey: ['currentCapAmount', id],
    queryFn: () => fetchCurrentCapAmount(id),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

const fetchCapConfiguration = async (id) => {
  return api.get(`offer-action/current-cap-amount/cap-configuration/${id}`).then((res) => res.data);
};

export const useCapConfiguration = (id, enabled = true) =>
  useQuery({
    queryKey: ['capConfiguration', id],
    queryFn: () => fetchCapConfiguration(id),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: enabled && !!id,
  });

const fetchCurrentCapAmountByDomains = async (id, domains) => {
  return api
    .get(`offer-action/current-cap-amount/daily/${id}?domain=${domains.join('&domain=')}`)
    .then((res) => res.data);
};

export const useCurrentCapAmountByDomains = (id, domains) =>
  useQuery({
    queryKey: ['currentCapAmount', id, domains],
    queryFn: () => fetchCurrentCapAmountByDomains(id, domains),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    disabled: !domains.length || domains.length === 0,
    initialData: 0,
  });

const fetchMarketingPartnersWithActions = async () => {
  return api.get('marketing_partner/withActions').then((res) => sortByName(res.data));
};

export const useMarketingPartnersWithActions = (isTcpaCompliant = false) =>
  useQuery({
    queryKey: ['marketingPartnersWithActions'],
    queryFn: fetchMarketingPartnersWithActions,
    enabled: isTcpaCompliant,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

const fetchKafkaPublishTopics = async () => {
  return api.get('kafka-publish-topics').then((res) => res.data);
};

export const useKafkaPublishTopics = () =>
  useQuery({
    queryKey: ['kafkaPublishTopics'],
    queryFn: fetchKafkaPublishTopics,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    // No initialData: it would mark the query as already-successful, hiding isLoading/isError
    // from the topic dropdown forever.
  });
